// src/pages/PhentabSTS.js
import React from "react";
export default function PhentabSTS(){ return <div><h2>Phentab STS</h2><p>Coming soon…</p></div>; }